<template>
  <article class="flex flex-col">
    <h1 class="mb-[24px] font-roboto text-[32px] font-medium leading-6">
      Тесты
    </h1>
    <CommonComplexFiltering
      :key="isAnyFiltersActive"
      class="mb-[20px]"
      :rubrics-list="rubrics?.data?.value"
      :sort-options="sortOptions"
      is-centuries-disabled
      :filters-active="filters"
    />
    <div class="-m-2.5 flex flex-wrap">
      <MainPageCardsReworkedBaseCard
        v-for="test in tests?.data?.value"
        :key="test.id"
        class="w-full max-w-[100%] p-2.5 sm:max-w-[50%] xl:max-w-[33.33333%]"
        :data="test"
      >
        <template #badge
          ><span class="px-[32px] py-[8px] text-[12px]"
            >Вопросы: {{ test.questions }} Время: {{ test.time }} минут</span
          ></template
        >
      </MainPageCardsReworkedBaseCard>
    </div>
    <div class="mt-[64px] flex justify-center">
      <BaseTheButtonNew
        v-if="tests.hasNextPage.value"
        text="Показать еще"
        @click="tests.fetchNextPage()"
      />
    </div>
  </article>
</template>

<script setup>
const route = useRoute();

const filters = computed(() => {
  return {
    sort_by: route.query?.sort_by,
    category: route.query?.category,
  };
});

const { tests, resetPage } = useTests({ filters, per_page: 9 });
const { rubrics } = useTestsCategories();

watch(filters, (_, prevValue) => resetPage(prevValue));

const isAnyFiltersActive = computed(() => Object.values(route.query).length);

const sortOptions = [
  { id: 0, label: 'Свежие', value: '', icon: 'timer' },
  { id: 1, label: 'Популярные', value: 'views', icon: 'eye' },
  { id: 2, label: 'Любимые', value: 'likes', icon: 'like' },
];
</script>
